/** Owner's default for finished Bliss upgrades: raw materials cost × 10. */
export const BLISS_UPGRADE_MATERIALS_MULTIPLIER = 10

export function finishedUpgradePrice(rawMaterialsCost: number): number {
  if (!Number.isFinite(rawMaterialsCost) || rawMaterialsCost < 0) {
    throw new Error('Upgrade pricing requires a confirmed nonnegative raw materials cost.')
  }
  return Math.round(rawMaterialsCost * BLISS_UPGRADE_MATERIALS_MULTIPLIER * 100) / 100
}
